<template>
  <div class="jc-trafficDetail-container"
       v-loading="loading">
    <permission @permissionHandle="permissionHandle"></permission>
    <div class="jc-page-header"
         v-if="permission">
      <h1>
        <a @click="goBack"
           href="javascript:void(0)">
          <i class="el-icon-arrow-left"></i>
        </a>
        {{$t('bwTraffic.trafficDetail')}}
        <small>{{bandwidthName}}</small>
      </h1>
    </div>
    <div class="jc-page-content"
         v-if="permission">
      <el-tabs @tab-click="handleTabChange"
               v-model="activeTabName">
        <el-tab-pane :label="$t('bwTraffic.resourceInfo')"
                     name="resource">
          <traffic-info :info="this.trafficDetail"
                        v-loading="loadingDetail"></traffic-info>
        </el-tab-pane>
        <el-tab-pane :label="$t('bwTraffic.controlInfo')"
                     name="monitor">
          <div class="select-bar">
            <!-- 端口筛选 -->
            <el-row style="margin-bottom: 10px;display:flex">
              <span style="line-height: 30.4px;">
                {{$t('bwTraffic.ipAndPort',[$t('bwTraffic.switchIP'),$t('bwTraffic.port')])
                | withColon}}&nbsp;</span>
              <el-select @change="onDateRangeChange(false)"
                         style="width:300px"
                         v-model="switchPortIndex">
                <el-option :label="$t('bwTraffic.all')"
                           value="all"></el-option>
                <el-option :key="item.value"
                           :label="item.ip?(item.ip + ',' + item.port):(item.port)"
                           :value="index"
                           v-for="(item,index) in this.trafficDetail.switchboard"></el-option>
              </el-select>
            </el-row>
            <!-- 时间筛选 -->
            <el-row style="margin-bottom: 10px;display:flex"
                    v-if="activeTabName == 'monitor'">
              <date-range @change="onDateRangeChange(false)"
                          :default-value="defaultValue"
                          v-if="activeTabName == 'monitor'"
                          max-range-days="90"
                          shortcut-days="1h,6h,12h,24h,3d,7d,14d,30d"
                          style="display:inline-block"
                          :is-linkage-shortcuts="false"
                          :use-whole-day-shortcuts="false"
                          v-model="dateRangeValue"/>
              <div :style="'position: relative;top:2px;'" :class="['date-range-tips',{'date-range-color': dateRangeTips} ]">
                {{$t('bwTraffic.day31range')}}</div>
            </el-row>
          </div>
          <el-row>
            <el-col :span="24">
              <div class="dyn-env-box"
                   v-loading="chartLoading">
                <div class="header"
                     v-if="dynamicEnvData">
                  <p>{{this.$t('bwTraffic.powerTrendChart')}}</p>
                  <p>{{this.$t('cabinet.period') | withColon }} {{periodTag}}</p>
                </div>
                <div class="main">
                  <!--动环图表-->
                  <dynamic-env-chart :electric-currents="dynamicEnvData"
                                     :is-empty="isChartEmpty"
                                     :periodTag="periodTag"
                                     :switchPortIndex="switchPortIndex"
                                     :dateRangeValue="dateRangeValue"
                                     :series-names="seriesNames"
                                     :y-axis-name="yAxisName"
                                     :zoom-bar="false"
                                     unit="Mbps"
                                     v-if="activeTabName == 'monitor' && dynamicEnvData"
                                     width="100%" />
                  <el-empty v-else :description="$t('text.noSearch')"></el-empty>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane :label="$t('alarmHistory.alarmRule')"
                     name="alarmRules">
          <alarm-rules v-if="activeTabName === 'alarmRules'"
                       ref="alarmRules"
                       :bandwidthId="bandwidthId"
                       :idcId="idcId"></alarm-rules>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import TrafficInfo from './opt/TrafficInfo';
import DateRange from '@/components/common/DateRange';
import ChartHelper from './chart.helper';
import DynamicEnvChart from '@/components/common/DynamicEnvChart';
import permission from './opt/Permission';
import AlarmRules from './opt/AlarmRules';
// import {removeLong} from '@/axiosHandler/removeLong';
// import { handleChangeAllSelectedValue } from '@/utils/common/index';

const ONE_HOUR = 3600 * 1000;
const MAX_DATE_RANGE = 31;
const BANDWIDTH_TRAFFIC_CANCEL_NAME = 'getBandwidthTrafficInfoCancel';

// 增加一个变量，存储轮询间隔
let POLL_INTERVAL = 60000; // 默认1分钟

export default {
  components: {
    TrafficInfo,
    permission,
    DateRange,
    DynamicEnvChart,
    AlarmRules
  },
  data () {
    return {
      permission: false,
      loading: true,
      loadingDetail: false,
      bandwidthName: '',
      bandwidthId: 0,
      idcId: 0,
      defaultValue: '24h',
      chartLoading: false,
      activeTabName: 'resource',
      curTabName: 'resource',
      trafficDetail: {},
      switchPortIndex: 'all',
      hour: '24',
      yAxisName: '',
      seriesNames: '',
      daterange: [],
      dynamicEnvData: {},
      dateRangeValue: null,
      isChartEmpty: false,
      dateRangeTips: false,
      // periodTag: '5min'
      periodTag: '--',
      monitorPollTimer: null,
      trafficReqSeq: 0,
      latestTrafficReqSeq: 0
    };
  },
  created () { },
  mounted () { },
  beforeDestroy () {
    this.clearMonitorPolling();
    this.$api.removeCancel(BANDWIDTH_TRAFFIC_CANCEL_NAME);
  },
  computed: {},
  methods: {
    startMonitorPolling () {
      try {
        this.clearMonitorPolling();
        // 根据 periodTag 动态计算轮询时间
        const tag = this.periodTag;
        let interval = 60000;
        if(tag && tag !== '--'){
          const num = parseInt(tag);
          const unit = tag.replace(num,'');
          if(unit === 's') interval = num * 1000;
          if(unit === 'min') interval = num * 60 * 1000;
        }
        POLL_INTERVAL = interval;
        this.monitorPollTimer = setTimeout(() => {
          if (this.activeTabName !== 'monitor') return;
          this.onDateRangeChange(true);
        }, POLL_INTERVAL);
      } catch (error) {
        this.$message.error(error || '启动监控轮询失败');
      }
    },

    clearMonitorPolling () {
      if (!this.monitorPollTimer) return;
      clearTimeout(this.monitorPollTimer);
      this.monitorPollTimer = null;
    },
    getPeriodDuration () {
      const tag = this.periodTag;
      if (!tag || tag === '--') return 0;
      const num = parseInt(tag, 10);
      if (!Number.isFinite(num) || num <= 0) return 0;
      const unit = tag.replace(num, '');
      if (unit === 's') return num * 1000;
      if (unit === 'min') return num * 60 * 1000;
      return 0;
    },
    alignTimestampByPeriod (ts) {
      const periodDuration = this.getPeriodDuration();
      if (!periodDuration || !Number.isFinite(ts)) return ts;
      return Math.floor(ts / periodDuration) * periodDuration;
    },
    // 判断权限
    permissionHandle (per) {
      this.loading = false;
      this.permission = per;
      if (!this.permission) return;
      this.bandwidthName = this.$route.query.bandwidthName;
      this.activeTabName = this.$route.query.tabName;
      this.curTabName = this.$route.query.tabName;
      this.idcId = this.$route.query.idcId;
      this.bandwidthId = this.$route.params.id;
      if (this.activeTabName === 'resource') {
        this.clearMonitorPolling();
        this.getBandwidthInfo();
      }
      if (this.activeTabName === 'monitor') {
        this.initGraphInfo();
        this.startMonitorPolling();
        this.getBandwidthInfo();
        // this.$api.getBandwidthInfo({
        //   bandwidthId: this.bandwidthId,
        //   idc: this.idcId
        // }).then((res) => {
        //   if (res.errno === 10000 && res.errmsg === 'OK' && res.data) {
        //     this.trafficDetail = res.data.bandwidthTraffic;
        //   } else {
        //     this.trafficDetail = {};
        //     this.$message.error(res.errmsg);
        //   }
        // });
      }
      if (this.activeTabName === 'alarmRules') {
        this.clearMonitorPolling();
      }
    },

    // 带宽流量详情资源信息
    async getBandwidthInfo (params) {
      const tempParams = {
        bandwidthId: this.bandwidthId,
        idc: this.idcId
      };
      this.loadingDetail = true;
      const newParams = params || tempParams;
      // 选择下拉筛选的“全部”all
      // newParams = {...newParams, ...handleChangeAllSelectedValue(this.idcId)}
      const res = await this.$api.getBandwidthInfo(newParams);
      this.loadingDetail = false;
      if (res.errno === 10000 && res.errmsg === 'OK' && res.data) {
        this.trafficDetail = res.data.bandwidthTraffic;
        if (res.data.bandwidthTraffic.switchboard.length == 0) {
          const params = {
            bandwidthId: this.bandwidthId,
            idc: this.idcId
          }
          // 选择下拉筛选的“全部”all
          // params = {...params, ...handleChangeAllSelectedValue(this.idcId)}
          const response = await this.$api.listBigBandwidthPorts(params);
          const switchboard = [];
          if (response.data.ports.length > 0) {
            response.data.ports.forEach((el) => {
              switchboard.push({
                ip: '',
                port: el
              });
            });
          }
          console.log(switchboard);
          this.trafficDetail.switchboard = switchboard;
        }
      } else {
        this.trafficDetail = {};
        this.$message.error(res.errmsg);
      }
      // this.$api.getBandwidthInfo(newParams).then((res) => {

      // }).finally(() => {
      //   this.loadingDetail = false;
      // });
    },

    // 初始化图例信息
    initGraphInfo () {
      this.yAxisName = this.$t('bwTraffic.trafficUnit');
      this.seriesNames = `${this.$t('bwTraffic.totalUpRealTraffic')},${this.$t('bwTraffic.totalDownRealTraffic')}`;
    },

    handleTabChange ({ name }) {
      if (this.curTabName === name) return;
      this.curTabName = name;
      if (name === 'resource') {
        this.clearMonitorPolling();
        this.trafficDetail = {};
        this.getBandwidthInfo();
      }
      if (name === 'monitor') {
        this.switchPortIndex = 'all';
        this.dynamicEnvData = {};
        this.defaultValue = '24h';
        this.clearMonitorPolling();
        this.startMonitorPolling();
        this.getBandwidthInfo();
        // this.initGraphInfo();
        // this.onDateRangeChange();
      }
      if (name === 'alarmRules') {
        this.clearMonitorPolling();
        if (!this.$refs.alarmRules) return;
        this.$refs.alarmRules.getAlarmRulesList();
      }
    },

    showEmptyChart () {
      // const [startTime, endTime] = this.dateRangeValue;
      let [startTime, endTime] = [null, null];
      if (this.dateRangeValue === '') {
        [startTime, endTime] = this.getDefaultTime();
      } else {
        [startTime, endTime] = this.dateRangeValue;
      }
      this.dynamicEnvData = ChartHelper.getEmptyData(startTime, endTime);
      this.isChartEmpty = true;
    },

    handleDateChange (date) {
      const tempParams = {
        bandwidthId: this.bandwidthId,
        idc: this.idcId
      };
      const time = date.split('-');
      tempParams.startTime = time[0];
      tempParams.endTime = time[1];
      tempParams.ip = this.trafficDetail.switchboard[this.switchPortIndex].ip;
      tempParams.port = time[1];
    },

    getDefaultTime () {
      const now = Date.now();
      const start = new Date(now);
      // console.log(moment(start.getTime()).format('YYYY-MM-DD HH:mm:ss'));
      // console.log(moment(start.getTime() - ONE_HOUR * 24).format('YYYY-MM-DD HH:mm:ss'));
      const [startTime, endTime] = [start.getTime() - ONE_HOUR * 24, start.getTime()];
      return [startTime, endTime];
    },

    // 带宽流量详情监控信息
    onDateRangeChange (isPolling = false) {
      // debugger;
      if (!this.bandwidthId || !this.idcId) return;

      // 图例渲染
      if (this.switchPortIndex === 'all') { // 总带宽流量
        this.seriesNames = `${this.$t('bwTraffic.totalUpRealTraffic')},${this.$t('bwTraffic.totalDownRealTraffic')}`;
      } else { // 单个端口带宽流量
        this.seriesNames = `${this.$t('bwTraffic.upRealTraffic')},${this.$t('bwTraffic.downRealTraffic')}`;
      }
      const bandwidthId = this.bandwidthId;
      const idcId = this.idcId;
      // 清空日期选择器返回''要求默认显示24h数据
      let [startTime, endTime] = [null, null];
      if (this.dateRangeValue === '') {
        this.defaultValue = '24h';
        if (!isPolling) return;
        [startTime, endTime] = this.getDefaultTime();
      } else {
        [startTime, endTime] = this.dateRangeValue;
        this.defaultValue = '';
        if (isPolling) {
          const rangeDuration = endTime - startTime;
          const now = Date.now();
          endTime = this.alignTimestampByPeriod(now);
          if (rangeDuration > 0) {
            startTime = endTime - rangeDuration;
          }
        }
      }

      // 选择时间超过31天给出提示
      if (endTime - startTime > ONE_HOUR * 24 * MAX_DATE_RANGE) {
        this.dateRangeTips = true;
        return;
      }

      // 选择时间小于等于1小时 周期为1 min
      // this.periodTag = '5min';
      // if (endTime - startTime <= ONE_HOUR) {
      //   this.periodTag = '1min';
      // }
      this.dateRangeTips = false;

      let reqParam = {
        bandwidthId, startTime, endTime
      };
      reqParam.idc = idcId;

      if (this.switchPortIndex === 'all') {
        reqParam.all = 1;
      } else {
        const { ip, port } = this.trafficDetail.switchboard[this.switchPortIndex];
        reqParam = { ...reqParam, ip, port };
      }

      const reqSeq = ++this.trafficReqSeq;
      this.latestTrafficReqSeq = reqSeq;
      // 搜索请求保持原逻辑显示loading；轮询不主动开启
      this.chartLoading = !isPolling || this.chartLoading;

      this.$api.removeCancel(BANDWIDTH_TRAFFIC_CANCEL_NAME);
      // 选择下拉筛选的"全部"all
      // reqParam = {...reqParam, ...handleChangeAllSelectedValue(this.idcId)}
      let keepLoadingOnCancel = false;
      this.$api.getBandwidthTrafficInfo(reqParam).then((response) => {
        if (reqSeq !== this.latestTrafficReqSeq) return;
        const { data } = response || {};
        const { bandwidthTraffics, granularity } = data || {}
        // 格式化流量数据传递折线图组件
        // this.formatTrafficData(data);
        this.formatTrafficData(bandwidthTraffics);
        this.periodTag = granularity || '--';
        this.clearMonitorPolling();
        this.startMonitorPolling();
      }).catch((err) => {
        if (reqSeq !== this.latestTrafficReqSeq) return;
        if (err && err.__CANCEL__) {
          // 取消请求：保持loading，等待下一次有效响应再关闭
          keepLoadingOnCancel = true;
          this.chartLoading = true;
          return;
        }
        this.dynamicEnvData = null;
      }).finally(() => {
        if (reqSeq !== this.latestTrafficReqSeq) return;
        if (keepLoadingOnCancel) return;
        this.chartLoading = false;
      });
    },

    formatTrafficData (obj) {
      // 返回数据为空
      if (Array.isArray(obj) && !obj.length) {
        this.dynamicEnvData = null;
        this.showEmptyChart();
        return;
      }
      this.isChartEmpty = false;
      const dynamicEnvDataCopy = {};
      Object.keys(obj).forEach((item) => {
        dynamicEnvDataCopy[item] = [];
        dynamicEnvDataCopy[item].push(obj[item].in);
        dynamicEnvDataCopy[item].push(obj[item].out);
      });
      this.dynamicEnvData = dynamicEnvDataCopy;
    },

    goBack () {
      this.$router.push('/bandwidthtraffic/list');
    }
  }
};
</script>
<style lang="scss" scoped>
.jc-trafficDetail-container {
  // 设置footer分页(勿动)
  background-color: #f6fafd;
  height: 100%;
  overflow: auto;
  .el-tabs {
    background: #fff !important;
    padding: 6px 16px;
  }
  .my-date-picker {
    margin-left: 10px;
  }
  .dyn-env-box {
    height: 460px;
    margin: 15px 0;
    border: 1px solid #dcdcdc;

    .header {
      background: #f6fafd;
      padding: 4px 9px;

      p {
        line-height: 22px;
        margin: 1px 0 0 1px;
        font-size: 12px;
        color: rgba($color: #000000, $alpha: 0.65);
      }
    }
  }
  .date-range-tips {
    display: inline-block;
    line-height: 30px;
    top: 10px;
    color: #212121;
    font-size: 10px;
  }
  .date-range-color {
    color: red;
  }
}
.jc-trafficDetail-container /deep/ .el-table__body-wrapper {
  overflow: hidden;
}
.el-empty {
  margin-top: 80px !important; 
}
</style>



// WEBPACK FOOTER //
// src/components/bandwidthTraffic/TrafficDetail.vue